<template>
  <div class="accordion-item">
    <div class="accordion-item-content" @click="itemClicked()">
      <table v-if="global.screenWidth >= 1008" class="sewist-table-structure">
        <tbody>
          <tr>
            <td>
              <div class="profilepicture">
                <!-- Replace div with img-->
              </div>
              <div class="organization-location">
                <span class="organization">{{item.organization}}</span>
                <span class="location">{{item.city}}</span>
              </div>
            </td>
            <td>{{item.requestId}}</td>
            <td>{{moment(item.requestTimestamp).format('l')}}</td>
            <td>{{item.cityCenter}}</td>
            <td>{{parseInt(item.masks) - parseInt(item.masksCommitted)}}</td>
            <td>{{parseInt(item.caps) - parseInt(item.capsCommitted)}}</td>
            <td>{{parseInt(item.other) - parseInt(item.otherCommitted)}}</td>
          </tr>
        </tbody>
      </table>
      <!--  MOBILE ACCORDION ROW -->
      <div v-else class="flex-col">
        <div class="organization-location">
          <span class="organization">Organization: {{item.organization}}</span>
        </div>

        <span class="mobile-table-row">
          <strong>Request #:</strong>
          {{item.requestId}}
        </span>
        <span class="mobile-table-row">
          <strong>Date Created:</strong>
          {{moment(item.requestTimestamp).format('l')}}
        </span>
        <span class="mobile-table-row">
          <strong>City Center:</strong>
          {{item.cityCenter}}
        </span>
        <span class="mobile-table-row">
          <strong>Masks/Caps/Other</strong>
        </span>
        <span
          class="mobile-table-row"
        >{{parseInt(item.masks) - parseInt(item.masksCommitted)}} / {{parseInt(item.caps) - parseInt(item.capsCommitted)}} / {{parseInt(item.other) - parseInt(item.otherCommitted)}}</span>
      </div>
    </div>
    <div :id="itemId" class="description-container">
      <div class="description-content">
        <h6>
          If you have PPE ready, or will have PPE ready
          <span>within 7 days</span>, fill out this form.
        </h6>
        <div class="collection">
          <div class="collection-title">
            <span>Delivery Information</span>
            <div class="title-spacer"></div>
          </div>
          <div class="collection-content">
            <div class="collection-row">
              <div class="row-item row-item--row">
                <div class="form-value contact-info">
                  <div class="form-address">
                    <span>City Center:</span>
                    <span>{{item.cityCenter}}</span>
                    <span>{{item.addressLine1}}</span>
                    <span>{{item.addressLine2}}</span>
                    <span>{{item.provinceState}}</span>
                    <span>{{item.cityTown}}</span>
                    <span>{{item.postalCode}}</span>
                    <br />
                    <span>Requesting Organization:</span>
                    <span>{{item.organization}}</span>
                    <span>{{item.firstName}} {{item.lastName}}</span>
                    <span>{{item.email}}</span>
                    <span>{{item.phoneNumber}}</span>
                  </div>
                </div>
                <div class="form-value additional-notes">
                  <div class="form-address">
                    <span>Additional Notes:</span>
                    <span>{{item.additionalNotes}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="collection">
          <div class="collection-title">
            <span>Contact Information</span>
            <div class="title-spacer"></div>
          </div>
          <div class="collection-content">
            <div class="collection-row">
              <div class="inner-row">
                <div class="row-item">
                  <div class="form-label">
                    First Name
                    <div v-if="errors.firstName" class="error">***</div>
                  </div>
                  <div class="form-value">
                    <input v-model="formValues.firstName" type="text" :placeholder="'First Name'" />
                  </div>
                </div>

                <div class="row-item">
                  <div class="form-label">
                    Last Name
                    <div v-if="errors.lastName" class="error">***</div>
                  </div>
                  <div class="form-value">
                    <input v-model="formValues.lastName" type="text" :placeholder="'Last Name'" />
                  </div>
                </div>
              </div>
              <div class="inner-row">
                <div class="row-item">
                  <div class="form-label">
                    Email
                    <div v-if="errors.email" class="error">***</div>
                  </div>
                  <div class="form-value">
                    <input v-model="formValues.email" type="text" :placeholder="'Email'" />
                  </div>
                </div>
                <div class="row-item">
                  <div class="form-label">
                    Phone Number
                    <div v-if="errors.phoneNumber" class="error">***</div>
                  </div>
                  <div class="form-value">
                    <input
                      v-model="formValues.phoneNumber"
                      type="text"
                      :placeholder="'Phone Number'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="collection">
          <div class="collection-title">
            <span>Your PPE Contributions</span>
            <div class="title-spacer"></div>
          </div>
          <div class="collection-content">
            <div class="collection-row">
              <div class="collection-column">
                <div class="inner-row ppe-contributions">
                  <div class="row-item">
                    <div class="form-label">
                      <div
                        v-if="errors.masks"
                        class="error"
                      >{{typeof errors.masks === 'string' ? errors.masks : '***'}}</div>Masks
                      <span
                        v-show="parseInt(item.masks) - parseInt(item.masksCommitted) >= 1"
                      >({{parseInt(item.masks) - parseInt(item.masksCommitted)}} Outstanding)</span>
                    </div>
                    <div class="form-value">
                      <input
                        v-model="formValues.masks"
                        type="number"
                        :placeholder="0"
                        min="0"
                        max="200"
                      />
                    </div>
                  </div>
                  <div class="row-item">
                    <div class="form-label">
                      <div
                        v-if="errors.caps"
                        class="error"
                      >{{typeof errors.caps === 'string' ? errors.caps : '***'}}</div>Caps
                      <span
                        v-show="parseInt(item.caps) - parseInt(item.capsCommitted) >= 1"
                      >({{parseInt(item.caps) - parseInt(item.capsCommitted)}} Outstanding)</span>
                    </div>
                    <div class="form-value">
                      <input
                        v-model="formValues.caps"
                        type="number"
                        :placeholder="0"
                        min="0"
                        max="200"
                      />
                    </div>
                  </div>
                </div>
                <div class="inner-row">
                  <div class="row-item">
                    <div class="form-label">
                      <div
                        v-if="errors.other"
                        class="error"
                      >{{typeof errors.other === 'string' ? errors.other : '***'}}</div>Other
                      <span
                        v-show="parseInt(item.other) - parseInt(item.otherCommitted) >= 1"
                      >({{parseInt(item.other) - parseInt(item.otherCommitted)}} Outstanding)</span>
                    </div>
                    <div class="form-value">
                      <input
                        v-model="formValues.other"
                        type="number"
                        :placeholder="0"
                        min="0"
                        max="200"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="collection-row">
                <div class="row-item">
                  <div class="form-label">Additional Notes</div>
                  <div class="form-value">
                    <textarea
                      v-model="formValues.additionalNotes"
                      placeholder="Additional notes"
                      maxlength="300"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="collection">
          <div class="collection-content">
            <div class="collection-row">
              <div class="row-item horizontal-row-item">
                <div class="form-label">Are these ready now?</div>
                <div class="form-value">
                  <button
                    :class="`red ${formValues.ready ? 'faded' : '' }`"
                    @click="formValues.ready = false"
                  >No</button>
                  <button
                    :class="`green ${!formValues.ready ? 'faded' : '' }`"
                    @click="formValues.ready = true"
                  >Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="commit-btn" @click="createCommitment(item)">Commit</button>
      </div>
    </div>
  </div>
</template>

<script>
import fire from "@/config/fire.js";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import { validationHelper } from "@/helpers";
import moment from "moment";
export default {
  name: "AccordionItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemId: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    //dont delete this commit. REMINDER TO DELETE READY PROP FROM DB. STATUS IS SUFFICIENT
    return {
      formValues: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        masks: 0,
        caps: 0,
        other: 0,
        additionalNotes: "",
        adminNotes: "",
        ready: false,
      },
      errors: {},
    };
  },
  computed: {
    ...mapState(["global"]),
  },
  methods: {
    moment(date) {
      if (date) return moment(date);
      else return moment();
    },
    itemClicked() {
      this.$emit("clickCallback", this.itemId);
    },
    createCommitment(item) {
      this.errors = {};

      if (!item.requestId) {
        this.$swal("Error!", "Please try again later", "error");
      }

      if (this.checkEmpties()) {
        this.$swal("Error!", "Empty values not allowed", "error");
        return;
      }

      const url = process.env.VUE_APP_BASE_URL + "/api/createcommitment";

      let tempCommitment = this.formValues;

      tempCommitment.requestId = item.requestId;

      return axios({
        method: "post",
        url: url,
        data: {
          commitment: JSON.stringify(tempCommitment),
        },
      }).then((res) => {
        if (res.data && res.data && res.data.indexOf("success") > -1) {
          this.setUserData(res.data.userData);
          this.$swal({
            title: "Thank You!",
            text:
              "A confirmation email has been sent that includes the delivery address. Please deliver the PPE as soon as possible.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Okay",
          }).then((result) => {
            window.location = "https://thesewingarmy.com";
          });
          this.setLoggedIn(false);
          this.$router.push("/");
        } else {
          this.$swal("Error!", "Please try again later", "error");
        }
      });
    },
    getFireIdToken() {
      return fire.auth().currentUser.getIdToken();
    },
    checkEmpties() {
      let emptiesExist = false;

      if (
        !this.formValues.firstName ||
        this.formValues.firstName.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          firstName: true,
        };
      }
      if (!this.formValues.lastName || this.formValues.lastName.trim() === "") {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          lastName: true,
        };
      }
      if (
        !this.formValues.email ||
        this.formValues.email.trim() === "" ||
        !validationHelper.validateEmail(this.formValues.email)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          email: true,
        };
      }
      if (
        !this.formValues.phoneNumber ||
        this.formValues.phoneNumber.trim() === "" ||
        !validationHelper.validatePhone(this.formValues.phoneNumber)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          phoneNumber: true,
        };
      }

      if (
        this.formValues.masks === 0 &&
        this.formValues.caps === 0 &&
        this.formValues.other === 0
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: true,
          caps: true,
          other: true,
        };
      }

      if (
        this.formValues.masks >
        parseInt(this.item.masks) - parseInt(this.item.masksCommitted)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: "You cannot commit more than is outstanding",
        };
      }
      if (
        this.formValues.caps >
        parseInt(this.item.caps) - parseInt(this.item.capsCommitted)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          caps: "You cannot commit more than is outstanding",
        };
      }
      if (
        this.formValues.other >
        parseInt(this.item.other) - parseInt(this.item.otherCommitted)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          other: "You cannot commit more than is outstanding",
        };
      }
      if (this.formValues.masks < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: "Qty cannot be negative.",
        };
      }
      if (this.formValues.caps < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          caps: "Qty cannot be negative.",
        };
      }
      if (this.formValues.other < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          other: "Qty cannot be negative.",
        };
      }

      return emptiesExist;
    },
    ...mapActions(["setUserData", "setLoggedIn"]),
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
.accordion-item {
  color: black !important;
  overflow: hidden;
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;

  .faded {
    opacity: 0.5;
  }
  .accordion-item-content {
    cursor: pointer;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 0;
    background: #eeeeee;
    span {
      font-size: 15px;
      line-height: 15px;
      text-transform: uppercase;
      color: #000;
    }
    span.mobile-table-row {
      font-size: 14px;
      margin: 7px 0 7px 15px;
      strong {
        color: #8b8795;
      }
    }
    .profilepicture {
      height: 23px;
      width: 23px;
      border-radius: 50%;
      background: linear-gradient(to right, #20356d, #d83cb4);
      float: left;
      @media (max-width: $md) {
        display: none;
      }
    }
    .organization-location {
      display: flex;
      flex-direction: column;
      .organization {
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
      .location {
        opacity: 0.7;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
    }
  }
  .downArrow {
    justify-self: flex-end;
    font-size: 20px;
    color: #000;
    margin-right: 25px;
    margin-left: 4px;
    height: 100%;
    display: flex;
    align-items: center;
    align-self: center;
    @media (max-width: $xl) {
      font-size: 1rem;
      color: #ffffff;
    }
    .fa-chevron-down {
      transform: rotate(0deg);
      transition-duration: 0.3s;
    }
    .fa-chevron-down.rotate {
      transform: rotate(180deg);
      transition-duration: 0.3s;
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
  }
  .description-container {
    height: 0;
  }
  .description {
    height: 100%;
    font-size: 14px;
    color: #000000;
    .bold {
    }
  }
  .description-content {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 3px solid #eeeeee;
    padding: 24px 20px;
    h6 {
      font-size: 18px;
      color: #8b8795;
      letter-spacing: 0;
      line-height: 32px;
      span {
        color: #2ec693;
      }
    }
    .commit-btn {
      margin-top: 25px !important;
      border-radius: 5px;
      background-color: #2ec693;
      color: #fff;
    }
    .description {
      max-width: 625px;
    }
    @media (max-width: $lg) {
      padding: 15px 25px 15px 25px;
    }
  }

  .collection {
    margin-top: 35px;
    position: relative;
    .collection-title {
      display: flex;
      span {
        font-weight: 700;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        background-color: #fff;
        padding-right: 10px;
        z-index: 2;
      }
    }
    .title-spacer {
      width: 90%;
      height: 2px;
      background-color: #efefef;
      padding-right: 25px;
      position: absolute;
      right: 0;
      top: 6px;
      z-index: 1;
    }
    .collection-content {
      display: flex;
      flex-direction: row;
      .collection-column {
        flex: 1;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      }
      .collection-row {
        flex: 1;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        @media (max-width: $md) {
          flex-direction: column;
        }
        .inner-row {
          display: flex;
          flex-direction: row;
          @media (max-width: $sm) {
            flex-direction: column;
          }
        }
      }
      .ppe-contributions {
        @media (max-width: $md) {
          flex-direction: column;
        }
      }
      .row-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 8px;
        margin-top: 10px;
        &--row {
          flex-direction: row;
          @media (max-width: $md) {
            flex-direction: column;
          }
          .additional-notes {
            margin-left: 35px;
            @media (max-width: $md) {
              margin-left: 0px;
              margin-top: 25px;
            }
          }
          .contact-info {
            width: 50%;
            @media (max-width: $md) {
              width: 100%;
            }
          }
        }
        @media (max-width: $md) {
          padding: 8px;
        }
      }
      .horizontal-row-item {
        flex-direction: row;
      }
      button {
        color: #fff;
        border-radius: 5px;
      }
      .form-label {
        font-weight: 700;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        .checkmark {
          height: 14px;
          width: 14px;
          margin-right: 4px;
        }
      }
      .form-address {
        display: flex;
        flex-direction: column;
      }
      .form-value {
        display: flex;
        input {
          width: 100%;
          margin-top: 15px;
          border: 0px;
          padding: 15px;
          margin-right: 5px;
          color: #8b8795;
          font-size: 14px;
          background: #efefef;
          border-radius: 2px;
          &:focus {
            outline: #2ec693 solid 2px;
          }
        }
        textarea {
          width: 100%;
          background: #efefef;
          margin-top: 15px;
          border: 0px;
          padding: 15px;
          min-height: 100px;
          width: 200px;
          color: #8b8795;
          font-size: 14px;
          &:focus {
            outline: #2ec693 solid 2px;
          }
        }
        input,
        textarea {
          flex: 1;
          &::placeholder {
            font-weight: 700;
            font-size: 14px;
            color: #8b8795;
            letter-spacing: 0;
          }
        }
      }
    }
  }
}
.downArrow {
  justify-self: flex-end;
  font-size: 23px;
  color: #000 !important;
  margin-right: 25px;
  margin-left: 4px;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  img {
    transform: rotate(0deg);
    transition-duration: 0.3s;
    @media (max-width: $lg) {
      height: 7px;
      width: 7px;
    }
  }
  img.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  }
}
</style>
<style lang="scss">
.accordion-item {
  .description {
    span {
      color: red;
      &.bold {
        color: #000;
      }
    }
    .link {
      color: #000;
      cursor: pointer;
    }
  }
}
</style>

